// extracted by mini-css-extract-plugin
export default {"title":"Input_title__QX31H","hidden":"Input_hidden__xsvTX"};